import DataTile from "./DataTile";
import React from "react";
import {useSelector} from "react-redux";
import {
    bbFindEntityWithinPortfolioOrSelf,
} from "../../../util/bbHelpers";
import BBIconComputerAttentionVulnerability from "../../../assets/bbCustomIcons/BBIconComputerAttentionVulnerability";

const Tile = ({cycleId=null,}) => {

    // const {customerId} = props;

    const techDataVarName = "targets_with_vulns_total"

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {portfolios, entityInView} = useSelector(({breachrisk}) => breachrisk);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    const lastCycle = myEntity
    && myEntity.cycles
    && myEntity.settings
    && myEntity.settings.last_cycle_id
        ? myEntity.cycles[myEntity.settings.last_cycle_id] : null;

    const pastReportView = cycleId && lastCycle && cycleId !== lastCycle.id;

    const cycleInView = pastReportView
    && myEntity
    && myEntity.cycles
    && myEntity.cycles[cycleId]
        ? myEntity.cycles[cycleId]
        : lastCycle;

    const techData = myEntity
    && (lastCycle || cycleInView)
        ? cycleInView.techData
        : null;

    // const colorFunction = (stateData) => {
    //     return "light";
    // }

    const valueFunction = (stateData) => {

        const dataPointToDisplay = techData
        && techData.totals
            ?  techData.totals[techDataVarName]
            : null;

        return <span id={"numVulnHosts"}>{dataPointToDisplay}</span>;
    }


    return (
        <DataTile
            // color = {colorFunction()}
            // colorBgFunction={colorFunction}
            subTitle="Vulnerable Hosts"
            tipText={`The number of hosts that contain one or more NIST Common Vulnerabilities and Exposures (CVEs).  CVEs provide attack vector opportunities for attackers.`}
            icon={<BBIconComputerAttentionVulnerability style={{fontSize: "70px"}}/>}
            stateName="breachrisk"
            stateElement="portfolios"
            //useDeepDataStore
            // dontFetch
            forceLoadingState = {myEntity && myEntity.settings && myEntity.settings.last_cycle_id && techData ? false : true}
            valueFunction={valueFunction}
            // ribbonFunction={null}
            // requiresModule={"monitor"}
        />
    )

}

export default Tile;